(()=>{
 const $lists = document.querySelectorAll('[data-list]')
 
  $lists.forEach(($list) => {
    const listId = $list.getAttribute('data-list')
    const $buttonOpen = document.querySelector(`[data-button-open=${listId}]`)
    const $buttonClose = document.querySelector(`[data-button-close=${listId}]`)

    const openList = () => {
      $buttonOpen.classList.add('hidden')
      $buttonClose.classList.remove('hidden')
      $list.classList.remove('hidden')
      $list.classList.add('flex')
    }

    const closeList = () => {
      $buttonOpen.classList.remove('hidden')
      $buttonClose.classList.add('hidden')
      $list.classList.remove('flex')
      $list.classList.add('hidden')
    }

    $buttonOpen.addEventListener('click', (e) => {
      e.preventDefault()
      openList()
    })
  
    $buttonClose.addEventListener('click', (e) => {
      e.preventDefault()
      closeList()
    })
  })
})()




